import React from 'react';
import Moment from 'react-moment';
import moment from 'moment';
import { DatePicker } from '@material-ui/pickers';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import CalendarToday from '@material-ui/icons/CalendarToday';

const styles = () => ({
  wrapper: {
    marginBottom: 20,
  },
  heading: {
    marginBottom: 20,
  },
  calendarButton: {
    width: '100%',
    backgroundColor: '#f56a12',
    color: '#fff',
    textAlign: 'center',
    display: 'block',
    padding: '6px 4px',
    minWidth: 32,
    '&:hover': {
      backgroundColor: '#C24C03',
    },
  },
  calendarButtonText: {
    fontSize: 12,
  },
  dayWrapper: {
    padding: '9px 4px',
    textAlign: 'center',
    backgroundColor: '#edf2f5',
    color: '#bac2c7',
    cursor: 'pointer',
  },
  dayWrapperToday: {
    backgroundColor: '#2096f3',
    color: '#fff',
  },
  dayWrapperDay: {
    fontSize: 20,
    fontWeight: 'bold',
  },
  dayWrapperDayName: {
    fontSize: 14,
  },
});

class TimetableHeader extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isCalendarOpen: false,
    };

    this.onCalendarButtonClick = this.onCalendarButtonClick.bind(this);
  }

  onCalendarButtonClick() {
    this.setState({
      isCalendarOpen: true,
    });
  }

  render() {
    const {
      classes,
      t,
      dates,
      selectedDate,
      onCalendarDateChange,
      onDateClick,
    } = this.props;

    const {
      isCalendarOpen,
    } = this.state;

    const selectedDateMoment = selectedDate
      ? moment(selectedDate)
      : null;

    return (
      <div className={`timetable-header ${classes.wrapper}`}>
        {dates && (
          <Typography
            className={classes.heading}
            variant="h5"
            component="h5"
          >
            <Moment date={dates[0]} format="MMM" />
          </Typography>
        )}
        <Grid
          className={classes.headerSection}
          justify="flex-start"
          container
          spacing={2}
        >
          <Grid item xs={2}>
            <Button
              variant="contained"
              className={`timetable-header-calendar-button ${classes.calendarButton}`}
              onClick={this.onCalendarButtonClick}
            >
              <div>
                <CalendarToday />
                <div style={{ display: 'none' }}>
                  <DatePicker
                    variant="dialog"
                    inputVariant="filled"
                    label={t('Date')}
                    value={selectedDateMoment}
                    onChange={onCalendarDateChange}
                    format={dateFormat}
                    open={isCalendarOpen}
                    shouldDisableDate={day => day.weekday() === 5 || day.weekday() === 6}
                    onClose={() => {
                      setTimeout(() => {
                        this.setState({
                          isCalendarOpen: false,
                        });
                      });
                    }}
                    autoOk
                    okLabel={false}
                  />
                </div>
              </div>
              <div className={classes.calendarButtonText}>
                {t('Date')}
              </div>
            </Button>
          </Grid>
          {dates.map((date) => {
            let wrapperClassName = `${classes.dayWrapper}`;
            if (date === selectedDate) {
              wrapperClassName = `${classes.dayWrapper} ${classes.dayWrapperToday}`;
            }

            return (
              <Grid
                item
                xs={2}
                key={date}
                onClick={onDateClick.bind(this, date)}
              >
                <Paper className={wrapperClassName}>
                  <div className={classes.dayWrapperDay}>
                    <Moment date={date} format="DD" />
                  </div>
                  <div className={classes.dayWrapperDayName}>
                    <Moment date={date} format="ddd" />
                  </div>
                </Paper>
              </Grid>
            );
          })}
        </Grid>
      </div>
    );
  }
}

export default withStyles(styles)(withTranslation()(TimetableHeader));
